import React from "react";

const EXT_COLORS={pdf:"#D94F3D",docx:"#2B5EA7",xlsx:"#2D7D52",pptx:"#B07020"};
const EXT_LABELS={pdf:"PDF",docx:"Word",xlsx:"Excel",pptx:"PPT"};

function FileTypeIcon({ext,size=20}){
  const c=EXT_COLORS[ext]||"#6B6660";
  const l=EXT_LABELS[ext]||(ext?.toUpperCase().slice(0,3))||"FILE";
  return(
    <div style={{width:size,height:size,borderRadius:3,background:`${c}18`,border:`1px solid ${c}44`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
      <span style={{fontSize:size*0.3,fontFamily:"var(--fm)",fontWeight:600,color:c,lineHeight:1}}>{l}</span>
    </div>
  );
}

export default FileTypeIcon;
